import React from "react";
import styles from "./PaymentExpired.module.css";

// SVG Icons for modern premium UI
const AlertOctagonIcon = () => (
  <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={styles.warningIcon}>
    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
);

const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const InfoIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

const PaymentExpired = ({ alertResponse = {} }) => {
  const {
    title = "Subscription Expired",
    message = "Your school's subscription plan has expired. Please renew your plan to continue using the portal."
  } = alertResponse;

  // Filter out system control keys to render only details of the subscription/payment
  const EXCLUDED_KEYS = ["is_active", "alert_type", "is_scheduled", "server_time", "message", "title"];

  const displayDetails = Object.entries(alertResponse).filter(
    ([key]) => !EXCLUDED_KEYS.includes(key)
  );

  const formatKey = (key) => {
    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formatValue = (key, value) => {
    if (value === null || value === undefined) return "-";
    if (typeof value === "boolean") return value ? "Yes" : "No";

    // Auto-format ISO dates nicely
    if (key.includes("time") || key.includes("date") || key.includes("at")) {
      try {
        const parsedDate = new Date(value);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit"
          });
        }
      } catch (e) {
        // Fall back to original string
      }
    }
    return String(value);
  };

  const supportEmail = alertResponse.support_email || "contactus@gyansansaar.com";

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.card}>
          {/* Logo Section */}
          <div className={styles.logoSection}>
            <img
              src={require("../../../assets/brand.png")}
              alt="Gyansansaar Logo"
              className={styles.logoImage}
            />
          </div>

          {/* Warning Icon and Title */}
          <div className={styles.alertHeader}>
            <div className={styles.iconContainer}>
              <AlertOctagonIcon />
            </div>
            <h1 className={styles.title}>{title}</h1>
            <p className={styles.message}>{message}</p>
          </div>

          {/* Dynamic Details List */}
          {/* {displayDetails.length > 0 && (
            <div className={styles.detailsSection}>
              <div className={styles.detailsHeader}>
                <InfoIcon />
                <h3>Paid Between</h3>
              </div>
              <div className={styles.detailsGrid}>
                {displayDetails.map(([key, val]) => (
                  <div key={key} className={styles.detailItem}>
                    <span className={styles.detailKey}>{formatKey(key)}</span>
                    <span className={styles.detailValue}>{formatValue(key, val)}</span>
                  </div>
                ))}
              </div>
            </div>
          )} */}

          {/* Action section */}
          <div className={styles.actionSection}>
            <a href={`mailto:${supportEmail}`} className={styles.supportButton}>
              <MailIcon />
              <span>Contact Billing Support</span>
            </a>
            <p className={styles.footerNote}>
              If you believe this is in error, please contact your system administrator or reach us at <a href={`mailto:${supportEmail}`}>{supportEmail}</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentExpired;
